import {action, computed, makeObservable, observable, runInAction} from "mobx";
import CommonStore from "../../../../../stores/CommonStore";
import { CustomCategoryWeightRangeService } from "../../../../../service/packageDelivery/customCategory/CustomCategoryWeightRangeService";
import { CustomCategoryService } from "../../../../../service/packageDelivery/customCategory/CustomCategoryService";
import CustomCategory from "../../../../../model/packageDelivery/customCategory/CustomCategory";

class CustomCategorySalePriceStore {

    // public customCategoryWeightRanges: CustomCategoryWeightRange[];
    public customCategories: CustomCategory[];
    public commonStore: CommonStore;

    constructor(commonStore: CommonStore) {
        // this.customCategoryWeightRanges = [];
        this.customCategories = [];
        this.commonStore = commonStore;
        makeObservable(this, {
            // customCategoryWeightRanges: observable,
            customCategories: observable,
            isEmpty: computed
        });
    }

    get isEmpty(): boolean {
        return false;
    }

    @action
    public async searchCustomCategories(): Promise<void> {
        const response = await CustomCategoryService.get(1, 1000, '');
        if (response.success) {
            this.customCategories = response.data?.data || [];
            this.getCustomCategoryWeightRange();
        }
    }

    @action
    async getCustomCategoryWeightRange() {
        const response = await CustomCategoryWeightRangeService.getAll();
        if(response.success && response.data) {
            runInAction(() => {
                // this.customCategoryWeightRanges = response.data || []
            })
        }
    }

}

export default CustomCategorySalePriceStore;